import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Loader from '../loader/loader'
import './login.css'
import useToastNotification from '../../hooks/useToastNotification';
import { loginApi, sendNewCode, forgotPassword } from '../../utils/api'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import { Dialog } from 'primereact/dialog';
import Logo from '../../assets/images/LOGO.png';

const Login = () => {
    const [otpCode, setOtpCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [validated, setValidated] = useState(false);
    const [changePasswordValidate, setChangePasswordValidate] = useState(false);
    const [visible, setVisible] = useState(false);
    const [loader, setLoginLoader] = useState(false);
    const { showError, showSuccess } = useToastNotification();
    const [typePassword, setTypePassword] = useState('password');
    const [time, setTime] = useState(120); // Initialize with 2 minutes (120 seconds)
    const [isActive, setIsActive] = useState(false);
    const [resendBtn, setResendBtn] = useState(true);
    const [resendCode, setResendCode] = useState(false);
    const [checkOtpLoading, setCheckOtpLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const inputRefs = useRef([]);
    const [otpSend, setOptSend] = useState('');


    const handleOtpChange = (index, value) => {
        if (value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }


    //login
    const login = async (event, pass) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (otpCode == '') {
            showError('لطفا رمز عبور خود را وارد کنید.')
            return
        }
        // if (!acceptedTerms) {
        //     showError('لطفا قوانین و مفرارت را تایید کنید.')
        //     return
        // }
        if (form.checkValidity() === true) {
            event.stopPropagation();
            let ipAddress = await getIPAddress();
            let payload = {
                ip: ipAddress,
                mobile: mobile,
                password: otpCode
            }
            try {
                setLoginLoader(true)
                let loginRes = await loginApi(payload)
                if (loginRes && loginRes.data.res === 'OK') {
                    //save customerInfo in localStorage
                    const expireTime = Date.now() + 24 * 60 * 60 * 1000; // یک روز
                    window.localStorage.setItem('userInfo', JSON.stringify(loginRes.data));
                    window.localStorage.setItem('tokenExpireAt', expireTime);
                    setLoginLoader(false)
                    showSuccess('ورود با موفقیت انجام شد')
                    window.location.href = `/`;

                } else {
                    setLoginLoader(false)
                    let error = {
                        // title: loginRes.data.fullName,
                        text: loginRes.data.restp,
                    }
                    showError(error);
                }
            } catch (error) {
                setLoginLoader(false)
            }

        }
        setValidated(true);
    }


    //get IPAddress for login
    const getIPAddress = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Failed to fetch IP address:', error);
            return null;
        }
    }
    const showPassword = () => {
        setTypePassword('text')
    }
    const hidePassword = () => {
        setTypePassword('password')
    }

    //setTimer
    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish(); // Call the function when the timer reaches 0
        }
        // Cleanup interval on component unmount or when time reaches 0
        return () => clearInterval(timerId);
    }, [isActive, time]);

    //finishTimer
    const onTimerFinish = () => {
        setResendCode(true);
        setResendBtn(false);
    }


    const checkOtp = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            e.stopPropagation();
            // if (parseInt(getOtpValue()) == parseInt(otpSend)) {
            try {
                setCheckOtpLoading(true)
                let pay = {
                    mobile: mobile,
                    newPass: newPassword,
                    code: otp
                }
                console.log(pay)
                let res = await forgotPassword(pay)
                if (res.data.res == 'Ok') {
                    setCheckOtpLoading(false)
                    showSuccess(res.data.restp)
                    setVisible(false)
                }
                else {
                    setCheckOtpLoading(false)
                    showError(res.data.restp)
                }
            } catch (error) {
                setCheckOtpLoading(false)
            }
        }
        setChangePasswordValidate(true)

    }

    const gotoChangePass = async (e) => {
        if (mobile == '' || !mobile.startsWith('09') || mobile.length != 11) {
            showError('لطفا شماره همراه را به صورت صحیح وارد کنید.')
            return
        }





        setVisible(true)
        setOtp()

        try {
            setLoginLoader(true);
            let response = await sendNewCode(mobile);

            if (response.data.res === 'OK') {
                // Set interval for timer
                setResendCode(false);
                setTime(120);
                setIsActive(true);
                setLoginLoader(false);
                setOptSend(response.data.resTp)
                showSuccess('کد با موفقیت ارسال شد');

            } else if (response.data.res === 'NotOK') {
                setLoginLoader(false);

                let error = {
                    title: 'اخطار',
                    text: response.data.resTp,
                };
                showError(error);
            }
        } catch (error) {
            setLoginLoader(false);
            console.log(error);
        }


    };


    return (
        <>
            <h2 className='text-xl font-bold mt-4 text-right text-[#242526]'>ورود به حساب کاربری فروش عمده</h2>
            <Form className='login-form mt-4 row' noValidate validated={validated} onSubmit={(e) => login(e)}>
                {/* نام کاربری / شماره موبایل */}
                <Form.Group controlId="mobile" className=' col-12 col-md-6'>
                    <Form.Label className="text-sm text-[#242526]"> شماره همراه <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="number"
                        inputMode="numeric"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                    />
                </Form.Group>

                {/* رمز عبور / کد تایید */}
                <Form.Group controlId="otpCode" className="col-12 col-md-6 ">
                    <Form.Label className="text-sm text-[#242526]">رمز عبور <span className="text-danger">*</span></Form.Label>
                    <div className='input-icon pl-2'>
                        <Form.Control type={typePassword} dir='ltr' style={{direction: 'ltr'}} className='text-right' required value={otpCode} onChange={(e) => setOtpCode(e.target.value)}
                            onKeyDown={(e) => {

                                if (e.key === 'Enter') {
                                    e.preventDefault(); // Prevent form submission
                                    login(e); // Call login function
                                }
                            }} />
                        {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                    </div>

                </Form.Group>


                {/* شرایط و قوانین */}
                <div onClick={() => gotoChangePass()} className="text-[10px] text-[#e24c4c] text-right mt-2" style={{ textDecoration: 'underline', textUnderlineOffset: '3px', cursor: 'pointer' }}>فراموشی رمز عبور</div>
                {/* <Form.Check

                    className="mt-3 text-sm text-[#242526]"
                    label="شرایط و قوانین را قبول دارم."
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={(e) => setAcceptedTerms(e.target.checked)}
                /> */}



                {/* دکمه تأیید */}
                <button
                    type="submit"
                    disabled={loader}
                    className="btn btn-primary mx-auto mt-3 d-flex align-items-center gap-2 justify-center"
                >
                    ورود {loader && <Loader />}
                </button>


            </Form>
            <Dialog
                draggable={false}
                visible={visible}
                style={{ width: '40vw' }}
                breakpoints={{ '60vw': '60vw', '80vw': '90vw' }}
                onHide={() => setVisible(false)}
                className='login-dialog'
                dismissableMask
            >
                <div className='text-center'>
                    <img src={Logo} alt="" className='mx-auto' width={96} />
                </div>
                <p className='text-center mt-5'>لطفا کد ارسال شده به شماره {mobile} را وارد کنید.</p>

                <button className='btn border-0  w-100 text-left ' onClick={() => setVisible(false)} style={{ color: '#00a14b', justifyContent: 'end' }}>تغییر شماره موبایل</button>
                <Form className='login-form mt-4 row' noValidate validated={changePasswordValidate} onSubmit={(e) => checkOtp(e)}>
                    {/* نام کاربری / شماره موبایل */}
                    <Form.Group controlId="mobile" className=' col-12 col-md-6'>
                        <Form.Label className="text-sm text-[#242526]">کد ارسالی <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="number"
                            inputMode="numeric"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* رمز عبور / کد تایید */}
                    <Form.Group controlId="otpCode" className="col-12 col-md-6 ">
                        <Form.Label className="text-sm text-[#242526]">رمز عبور جدید <span className="text-danger">*</span></Form.Label>
                        <div className='input-icon pl-2'>
                            <Form.Control type={typePassword} required value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                                onKeyDown={(e) => {

                                    if (e.key === 'Enter') {
                                        e.preventDefault(); // Prevent form submission
                                        checkOtp(e); // Call login function
                                    }
                                }} />
                            {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                        </div>

                    </Form.Group>

                    <button type='button' disabled={resendBtn} className='btn mt-2 text-[#00a14b] text-center w-100 border-0 d-flex align-items-center justify-content-center gap-2 number' style={{ color: '#00a14b' }} onClick={(e) => gotoChangePass(e)}>
                        {resendCode ? 'ارسال مجدد' : formatTime(time)} </button>
                    {/* دکمه تأیید */}
                    <button
                        type="submit"
                        disabled={loader}
                        className="btn btn-primary mx-auto mt-3 d-flex align-items-center gap-2 justify-center"
                    >
                        ثبت {checkOtpLoading && <Loader />}
                    </button>


                </Form>


            </Dialog>
        </>

    );
};

export default Login;
